
import Vue from 'vue'
import SimpleBarrel from "@/components/SimpleBarrel.vue";
import BarrelCarousel from "@/components/BarrelCarousel.vue";
import { BarrelSummary } from "@/services/ApiService";
export default Vue.extend({
  name: 'CurrentAndOtherBarrels',
  components: {SimpleBarrel,BarrelCarousel},
  props: {
    customerName: String,
    customerPhoneNumber: String,
    barrels: {
      required: true,
      type: Array
    }
  },
  computed: {
    pybNumber(){
      return this.currentBarrel?.LogicalBarrelId?.split("_")[0];
    },
    currentBarrelRoute(){
      try{
        if(this.currentBarrel?.BarrelStatus === this.inCartStatus){
          return {
            name: 'Order',
            params: { barrelId: this.currentBarrel?.LogicalBarrelId },
          };
        }
      }catch {

      }

      return {
        name: 'Details',
        params: { barrelId: this.currentBarrel?.LogicalBarrelId },
      };
    }
  },
  data: () => ({
    selectedTab: null,
    tabs: [
      {title: 'Open', emptyMessage: 'No Barrel Is Currently Open.'},
      {title: 'Processing', emptyMessage: 'No Barrel Is Being Processed At The Moment.'},
      {title: 'Done', emptyMessage: 'No Barrel Has Been Completed Yet.'}
    ],
    currentBarrel: {} as BarrelSummary,
    processingBarrels: [] as BarrelSummary[],
    completedBarrels: [] as BarrelSummary[],
    inCartStatus: "In Cart" as string
  }),
  methods: {
    tabPress(){
      setTimeout(()=>{
        window.location.href = '#currentAndOtherBarrelsTabs'
      },500);
    },
    barrelCarousel(currentTabTitle: string){
      if(currentTabTitle === 'Processing' && this.processingBarrels.length) return {
        show: true,
        barrels: this.processingBarrels
      }
      if(currentTabTitle === 'Done' && this.completedBarrels.length) return {
        show: true,
        barrels: this.completedBarrels
      }
      return {show: false}
    },
    emptyMessage(currentTabTitle: string){
      if(currentTabTitle === 'Open' && !this.currentBarrel.LogicalBarrelId) return {
        show: true,
        message: this.getEmptyMessage('Open')
      }
      if(currentTabTitle === 'Processing' && this.processingBarrels.length === 0) return {
        show: true,
        message: this.getEmptyMessage('Processing')
      }
      if(currentTabTitle === 'Delivered' && this.completedBarrels.length === 0) return {
        show: true,
        message: this.getEmptyMessage('Delivered')
      }

      return {
        show: false
      }
    },
    getEmptyMessage(currentTabTitle: string){
      return this.tabs.find(tab => tab.title === currentTabTitle)?.emptyMessage ?? '';
    },
    categorizeBarrels(){
      const tempBarrels = this.barrels as BarrelSummary[];
      const processingBarrels: BarrelSummary[] = [];
      const completedBarrels: BarrelSummary[] = [];

      tempBarrels.forEach(barrel => {
        if(barrel.BarrelActive && !barrel.BarrelClosed) this.currentBarrel = barrel;
        if(barrel.BarrelActive && barrel.BarrelClosed) processingBarrels.push(barrel);
        if(!barrel.BarrelActive && barrel.BarrelClosed) completedBarrels.push(barrel);
      })

      this.processingBarrels = processingBarrels;
      this.completedBarrels = completedBarrels;
    }
  },
  mounted(){
    this.categorizeBarrels();
  }
})
